/**
 * @desc recSignResult
 */

import * as defs from '../../baseClass'
import axios from '@/services/request'

export class Params {
  /** sign */
  sign: string
}

export const init = undefined

export async function request(params) {
  return axios({
    url: '/api/scp-cashier-business/recSignResult/{sign}',
    data: params,
    method: 'patch',
  })
}
